import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, Box, DialogActions, Typography } from '@mui/material';
import styled from '@mui/system/styled';

import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
const StyledDialogTitle = styled(DialogTitle)({
    fontSize: '1.8rem',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#025366',
});

const StyledDialogContent = styled(DialogContent)({
    textAlign: 'center',
    padding: '20px 30px',
});

const StyledDialogActions = styled(DialogActions)({
    justifyContent: 'center',
    paddingBottom: '20px',
});

const StyledButton = styled(Button)({
    margin: '0 8px',
    padding: '10px 20px',
    fontSize: '1.1rem',
    textTransform: 'none',
    color: '#fff',
    backgroundColor: '#E57C22',
    '&:hover': {
        backgroundColor: '#d9731a',
    },
});



const OptionButton = styled(Button)({
    margin: '10px 8px',
    padding: '12px 25px',
    fontSize: '1.1rem',
    textTransform: 'none',
    color: '#025366',
    backgroundColor: '#f5f5f5',
    border: '1px solid #E57C22',
    width: 'auto',  // Allows the button to shrink when there are many buttons
    maxWidth: '200px',  // Set a maximum width to ensure consistency
    flexGrow: 1,  // Allows buttons to fill available space equally
    '&:hover': {
        backgroundColor: '#E57C22',
        color: '#fff',
    },
});

const ActionButton = styled(Button)({
    backgroundColor: '#304FFF', // Consistent background with other elements
    borderRadius: 4, // Same border-radius as MUI TextField and Switch
    color: 'white',
    height: '55px', // Same height as other input elements
    padding: '0 16px', // Consistent padding
    fontSize: '0.875rem', // Matching font size with TextField
    textTransform: 'none',
    boxSizing: 'border-box',
    '&:hover': {
        backgroundColor: '#F9AA2A', // Slightly darker on hover
    },
    '&:disabled': {
        backgroundColor: '#E0E0E0',
        color: '#BDBDBD',
    },
});
const 
SelectDocumentOptionDialog = ({
    open,
    onClose,
    onOptionSelect,
    splitInfo,
    selectedRowsNumber,
}) => {
    const { t } = useTranslation();
    
    const warningHtml = `
      ${selectedRowsNumber
            ? `<p style="color:#d33;font-weight:400">
             ${t('YouAreAboutToLock')} <b style="color:#d33;font-weight:800">${selectedRowsNumber}</b> ${t('Rows')}
           </p>`
            : ''
        }
      <p>${t('OnceLockedYouCannotEditOrDelete')}</p>
    `;

    const handleLockedClick = async () => {
        const result = await Swal.fire({
            title: t('AreYouSure'),
            html: warningHtml,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('YesLockIt'),
            cancelButtonText: t('NoCancel'),
            customClass: { container: 'swal-high-zindex' },
        });

        if (result.isConfirmed) onOptionSelect('locked');
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <StyledDialogTitle>{t('SelectOption')}</StyledDialogTitle>

            <StyledDialogContent>
                <Typography variant="body2" color="#025366">
                    {t('PleaseSelectOptionForSelectedRows')}
                </Typography>

                {/* Process / Un-process buttons disappear if everything is locked */}
                {!splitInfo.allLocked && (
                    <Box display="flex" flexWrap="wrap" justifyContent="center" mt={2}>
                        <OptionButton onClick={() => onOptionSelect('notDone')}>
                            {t('unprocessed')}
                        </OptionButton>

                        <OptionButton onClick={() => onOptionSelect('done')}>
                            {t('processed')}
                        </OptionButton>
                    </Box>
                )}

                {/* Lock and/or Storno */}
                <Box display="flex" flexWrap="wrap" justifyContent="center" mt={2}>
                    {splitInfo.anyUnlocked && (
                        <OptionButton onClick={handleLockedClick}>
                            {t('Locked')}
                        </OptionButton>
                    )}

                    {splitInfo.anyLocked && (
                        <OptionButton onClick={() => onOptionSelect('storno')}>
                            {t('CreateStorno')}
                        </OptionButton>
                    )}
                </Box>
            </StyledDialogContent>

            <StyledDialogActions>
                <StyledButton onClick={onClose}>{t('close')}</StyledButton>
            </StyledDialogActions>
        </Dialog>
    );
};

export default SelectDocumentOptionDialog;